import React from 'react';

import { Alert } from '@innovationnorway/cl-react';

import UnretireButton from './UnretireButton';
import { ClusterContactDto, ClusterContactStatus } from 'src/api/v2';
import { formatDateToNOString } from 'src/utils/FormatValue';

interface Props {
  clusterContact?: ClusterContactDto;
}

const InactiveNotification: React.FC<Props> = ({ clusterContact }) => {
  if (
    !clusterContact ||
    clusterContact.status === ClusterContactStatus.Active ||
    clusterContact.status === ClusterContactStatus.PendingApproval
  ) {
    return null;
  }

  return (
    <div className="margin-bottom--3">
      <Alert data-color="info">
        <div className="display--flex justify-content--space-between align-items--center">
          <div>
            <p>
              Denne kontakten er meldt ut, utmeldingsdato:
              {` ${formatDateToNOString(
                clusterContact.deactivatedDate!,
                false,
                '{date}.{month}.{year}',
                true,
              )}`}
            </p>
            <p>Kontakten kan ikke endres før den meldes inn igjen.</p>
          </div>
          <div>
            <UnretireButton clusterContact={clusterContact} />
          </div>
        </div>
      </Alert>
    </div>
  );
};

export default InactiveNotification;
